import { Controller } from '@hotwired/stimulus';
import { getCookie } from '../../modules/utils/cookie';
import validate, { instanceMethods } from '../../modules/validate/validate';
import inputStates from '../../modules/validate/inputStates';

export default class ConsentModalController extends Controller {
  static targets = ['form'];

  connect () {
    if (!getCookie('consent_given')) {
      this.open();
    }
    this.setFormValidations();
  }

  open () {
    this.element.classList.add('modal--open');
  }

  close () {
    this.element.classList.remove('modal--open');
    this.element.classList.add('modal--close');
  }

  setFormValidations () {
    inputStates();
    validate(this.formTarget, {
      findParentNode: this.findParentNode,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  findParentNode (currentInput) {
    if (currentInput.type === 'checkbox') {
      return currentInput.parentNode;
    }
    return currentInput.parentNode.parentNode;
  }

  submitRequest (event) {
    event.preventDefault();
    const form = event.target;
    const CSRFToken = form.querySelector('input[name="authenticity_token"]')?.value;
    const submitButton = form.querySelector('#consent-modal-form-submit');

    submitButton.disabled = true;
    fetch(form.action, {
      method: form.method,
      body: new FormData(form),
      headers: { 'X-CSRF-Token': CSRFToken },
    })
      .then(response => this.handleResponse(response))
      .catch(() => {
        // eslint-disable-next-line no-console
        console.error('There was an error while submitting the form');
      })
      .finally(() => {
        submitButton.disabled = false;
      });
  }

  handleResponse (response) {
    if (response.ok) {
      this.close();
    } else {
      response.json()
        .then(json => this.setFormErrors(json));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  setFormErrors (response) {
    Object.entries(response.errors).forEach((entry) => {
      const input = document.getElementById(`microsite_consent_${entry[0]}`);
      const message = entry[1];
      input.setCustomValidity(message);
      instanceMethods.findOrCreateErrorNode({
        input,
        errorMessage: message,
      });
    });
  }
}
